import React, {useEffect, useState} from "react";
import ModalPopUp from '../../../module/modalPopUp';
import {StepComponent} from '../../../module/step_component';
import {updateHeader, updateUrl} from '../../../store/actions/main';
import {updateEditZaun} from '../../../store/actions/zaune';
import {connect} from 'react-redux';
import Button from '@material-ui/core/Button';
import {zaune_auswahl} from '../../../../assets/images/data';
import ImageSlider from '../../../module/imageSlider';
import {ProductInfo} from '../../../module/productInfo';


const Index = (props) => {

   const [showModalStepper, setShowModalStepper] = useState(false);
   const [showModalInfo, setShowModalInfo] = useState(false);
   const [showModalImages, setModalImages] = useState(false);

   const closeModal = () => setShowModalStepper(false);
   const closeModalInfo = () => setShowModalInfo(false);
   const closeModalImages = () => setModalImages(false);

   const showStepper = ev => {
      let titel = ev.currentTarget.getAttribute('titel');
      props.updateUrl(titel);
      setShowModalStepper(true);
   }

   const showInfo = () => setShowModalInfo(true);
   const showImages = () => setModalImages(true);

   useEffect(() => {
        updateItems();
   })

   const updateItems = () => {
      props.updateHeader('Zäune');
      updateEdit();
   }

   const updateEdit = () => {
      let button = document.querySelector('.product_main_wrapper .button');
         if (props.isEdit) {
            button.click();
            props.updateEdit();
         }
   }


      return (
           <div className="product_main_wrapper">
               <div className='product_wrapper'>
                  <div className='inner-modell-wrapper-zaune'>
                     <ImageSlider
                        showImages={showImages}
                        imageposter={zaune_auswahl.portfolio}
                     />
                     <div className="button-wrapper">
                           <Button onClick={showStepper} titel="Zaun" className='button'>Konfigurator starten</Button>
                           <Button onClick={showInfo} className='button info'>Mehr Informationen</Button>
                     </div>
                  </div>
               </div>
            <ModalPopUp
                title="Zaun-Bilder"
                class='modell'
                component={<ImageSlider showModalImages={showModalImages} imageposter={zaune_auswahl.portfolio} />}
                showModal={showModalImages}
                hideModal={closeModalImages}
            />
            <ModalPopUp
                title="Zaun"
                class='modell'
                component={<StepComponent />}
                showModal={showModalStepper}
                hideModal={closeModal}
            />
            <ModalPopUp
                   title="Produktbeschreibung - Zaun"
                   class='modell'
                   component={<ProductInfo
                               type="einen Zaunfeld"
                               desc={zaune_auswahl.desc}
                               desc_items={zaune_auswahl.content}
                               price={`Ab ${props.price.toFixed(2)}€ / lfm`}
                               />}
                   showModal={showModalInfo}
                   hideModal={closeModalInfo}
                />
          </div>
       )
}

const mapStateToProps = state => {
   return {
      isEdit: state.zauneReducer.data.isEdit,
      price: state.zauneReducer.data.modell[0].price
   }
}

const mapStateToDispatch = dispatch => {
    return {
        updateHeader: ev => dispatch(updateHeader(ev)),
        updateUrl: ev => dispatch(updateUrl(ev)),
        updateEdit: () => dispatch(updateEditZaun())
    }
}

export default connect(mapStateToProps, mapStateToDispatch)(Index);

